/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetCostSummaryQueryResponse, GetCostSummaryPathParams, GetCostSummary400, GetCostSummary401, GetCostSummary403, GetCostSummary404, GetCostSummary409, GetCostSummary500 } from "../../types/platformBillingController/GetCostSummary.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetCostSummaryUrl(organizationId: GetCostSummaryPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/platform-billing/cost-summary` as const }
  return res
}

/**
 * @summary Get AI cost summary (spend vs budget, currency-projected)
 * {@link /api/organizations/:organizationId/platform-billing/cost-summary}
 */
export async function getCostSummary(organizationId: GetCostSummaryPathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetCostSummaryQueryResponse, ResponseErrorConfig<GetCostSummary400 | GetCostSummary401 | GetCostSummary403 | GetCostSummary404 | GetCostSummary409 | GetCostSummary500>, unknown>({ method : "GET", url : getGetCostSummaryUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}